import { AxiosPromise } from 'axios';
import { IrClaimTriageInfoDTO } from '../store/irClaimSlice';
import api from './api';

export default function updateClaimTriageInfo(
  id: number, updateBody: Partial<IrClaimTriageInfoDTO>,
) {
  return new Promise<AxiosPromise>((resolve, reject) => {
    try {
      api.patch(`ir-claim-triage-info/${id}`, updateBody)
        .then((response: any) => {
          resolve(response);
        })
        .catch((e: Error) => {
          reject(e);
        });
    } catch (e) {
      reject(e);
    }
  });
}
